// Ported 1:1 from the Webflow blog-post template (scraped/news/*.html), filled from posts.json.
import { useParams } from "react-router";
import CtaSection from "@/components/CtaSection";
import { findPost } from "@/content/posts";
import NotFoundPage from "./NotFoundPage";

export default function BlogPostPage() {
  const post = findPost(useParams().slug);
  if (!post) return <NotFoundPage />;

  return (
    <>
      <section className="section-top padding-0">
        <div style={{ opacity: "0" }} className="content">
          <div className="block-top">
            <a href="/blog" className="link-block back w-inline-block">
              <div className="block-icon-link">
                <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link back" />
              </div>
              <div className="text-link">Back</div>
            </a>
            <h1 className="heading-top">{post.title}</h1>
            <p className={`paragraph-top blog-post${post.subtitle ? "" : " w-dyn-bind-empty"}`}>{post.subtitle}</p>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content narrow">
          <img
            loading="eager"
            alt={post.title}
            src={post.featuredImage}
            sizes="(max-width: 479px) 87vw, (max-width: 767px) 92vw, (max-width: 1919px) 94vw, 960px"
            srcSet={post.featuredImageSrcSet || undefined}
            className="image-main-post"
          />
          <div className="post-body">
            <div className="rich-text-block w-richtext" dangerouslySetInnerHTML={{ __html: post.bodyHtml }} />
          </div>
        </div>
      </section>
      <CtaSection />
    </>
  );
}
